import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useFormatMessage } from 'app/common/hooks';
import { Portal } from 'app/common/components';
import itemAvailabilityMessages from '../ItemAvailability.messages';
import InventoryIndicator from './InventoryIndicator';
import cx from 'classnames';

const InventoryIndicatorModal = ({
  isOpen,
  onClose,
  locationQtys,
  quantity,
  targetDOMNode,
  partNumber,
  mini = false
}) => {
  const formatMessage = useFormatMessage();
  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = event => {
      if (
        isOpen &&
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);

  if (!isOpen || !targetDOMNode) {
    return null;
  }

  const modalClass = mini
    ? 'InventoryIndicatorModal--mini'
    : 'InventoryIndicatorModal--pdp';

  const textSize = mini ? 'text' : 'text-xl';

  const numericQuantity = Number(quantity);

  const addedItemLabel = formatMessage(itemAvailabilityMessages.addedItem, {
    quantity: numericQuantity,
    partNumber
  });

  return (
    <Portal target={targetDOMNode}>
      <div
        ref={containerRef}
        className={`${modalClass} bg-white shadow-xl border border-gray-200 rounded p-6`}
      >
        <div className="text-gray-700 space-y-3 text-lg">
          <p className={cx(textSize, 'font-semibold')}>{addedItemLabel}</p>
          <InventoryIndicator
            locationQtys={locationQtys}
            requestedQuantity={numericQuantity}
            sku={partNumber}
          />
        </div>
      </div>
    </Portal>
  );
};

InventoryIndicatorModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  locationQtys: PropTypes.object,
  quantity: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  targetDOMNode: PropTypes.oneOfType([
    PropTypes.instanceOf(Element),
    PropTypes.object,
    PropTypes.string
  ]),
  partNumber: PropTypes.string
};

export default InventoryIndicatorModal;
